/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Cursors({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M.594 6.97a1.6 1.6 0 0 1 1.957-1.918l5.695 1.47a1.6 1.6 0 0 1 .731 2.68l-.742.743 1.697 1.696a1.6 1.6 0 0 1 0 2.263l-.608.608a1.6 1.6 0 0 1-2.263 0l-1.697-1.696-.711.71c-.886.886-2.4.457-2.689-.762zm1.657-.756a.4.4 0 0 0-.489.48l1.37 5.794a.4.4 0 0 0 .672.19l1.56-1.56.425.424 2.12 2.121a.4.4 0 0 0 .566 0l.61-.608a.4.4 0 0 0 0-.566l-2.123-2.12-.423-.425 1.59-1.59a.4.4 0 0 0-.183-.67zm3.343-3.243a1.6 1.6 0 0 1 1.957-1.918l5.695 1.47a1.6 1.6 0 0 1 .731 2.68l-.742.743 1.697 1.696a1.6 1.6 0 0 1 0 2.263l-.608.608a1.6 1.6 0 0 1-2.263 0L10.709 9.16c-.303-.303-.361-.573-.3-.808.12-.467.773-.416 1.114-.075l1.387 1.386a.4.4 0 0 0 .565 0l.61-.608a.4.4 0 0 0 0-.566l-2.123-2.12-.423-.425 1.59-1.59a.4.4 0 0 0-.183-.67L7.25 2.215a.4.4 0 0 0-.489.48l.346 1.462a.6.6 0 0 1-1.168.277z" /></svg>;
}
;